//
//
//
//
//
//
//
import authApiService from "../../services/api/AuthApiService";
import authService from "../../services/AuthService";
export default {
  name: "LogoutHeader",
  methods: {
    logout: function logout() {
      var _this = this;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC",
        text: "از حساب کاربری خود خارج میشوید؟",
        acceptText: "بلی",
        cancelText: "خیر",
        accept: function accept() {
          _this.$vs.loading();

          authApiService.logout().then(function () {
            authService.logout();
            location.reload();
          });
        }
      });
    }
  }
};